<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة طلب عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/proRequest">طلب عقار</router-link></li>
              <li class="breadcrumb-item active">إضافة طلب</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header"><div class="card-title">إضافة طلب عقار</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSuccess" :message="message" />

              <form @submit.prevent="submitData()">
                <div class="card-body">
                  <!-- client lookup -->
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">جوال العميل: <span class="req">*</span></label>
                      <input type="text" class="form-control" placeholder="جوال العميل المسجل" @keyup="getClientData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label">اسم العميل:</label>
                        <div class="fw-bold">{{ userName }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الغرض: <span class="req">*</span></label>
                      <select class="form-control" v-model="purpose">
                        <option :value="null">اختر الغرض</option>
                        <option value="for_sale">للبيع</option>
                        <option value="for_rent">للإيجار</option>
                      </select>
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">نوع العقار: <span class="req">*</span></label>
                      <select ref="typesSelect" class="form-control" v-model="typeId">
                        <option :value="null">اختر نوع العقار</option>
                        <option v-for="t in typesList" :value="t.id" :key="t.id">{{ t.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">المنطقة: <span class="req">*</span></label>
                      <select ref="regionsSelect" class="form-control" v-model="regionId" @change="getCitiesList()">
                        <option :value="null">اختر المنطقة</option>
                        <option v-for="r in regionsList" :value="r.id" :key="r.id">{{ r.name }}</option>
                      </select>
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">المدينة: <span class="req">*</span></label>
                      <select ref="citiesSelect" class="form-control" v-model="cityId" @change="getNeighborhoodsList()">
                        <option :value="null">اختر المدينة</option>
                        <option v-for="c in citiesList" :value="c.id" :key="c.id">{{ c.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الحي:</label>
                      <select ref="neighborhoodsSelect" class="form-control" v-model="neighborhoodId">
                        <option :value="null">اختر الحي</option>
                        <option v-for="n in neighborhoodsList" :value="n.id" :key="n.id">{{ n.name }}</option>
                      </select>
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">عمر العقار:</label>
                      <select ref="agesSelect" class="form-control" v-model="ageId">
                        <option :value="null">اختر العمر</option>
                        <option v-for="a in agesList" :value="a.id" :key="a.id">{{ a.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">السعر من:</label>
                      <input type="number" class="form-control" v-model="priceFrom" min="0">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">السعر إلى:</label>
                      <input type="number" class="form-control" v-model="priceTo" min="0">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">المساحة من:</label>
                      <input type="number" class="form-control" v-model="area" min="0">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">المساحة إلى:</label>
                      <input type="number" class="form-control" v-model="areaTo" min="0">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">عدد الغرف:</label>
                      <input type="number" class="form-control" v-model="roomsCount" min="0">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">تفاصيل إضافية:</label>
                      <textarea class="form-control" rows="3" v-model="extraDetails" placeholder="تفاصيل الطلب..."></textarea>
                    </div>
                  </div>
                </div>

                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">إضافة</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'PropertyRequestCreate',
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSuccess: false,
      message: '',
      errorNumber: 0,

      userMobile: null,
      userId: null,
      userName: null,
      userLoader: false,

      purpose: null,
      typeId: null,
      regionId: null,
      cityId: null,
      neighborhoodId: null,
      ageId: null,
      priceFrom: null,
      priceTo: null,
      area: null,
      areaTo: null,
      roomsCount: null,
      extraDetails: null,

      typesList: [],
      regionsList: [],
      citiesList: [],
      neighborhoodsList: [],
      agesList: [],
    }
  },
  methods: {
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    getInitData(){
      this.$http.get('/api/admin/propertyRequests/init').then(({data}) => {
        this.regionsList = data.regionsList ?? [];
        this.typesList = data.typesList ?? [];
        this.agesList = data.agesList ?? [];
        this.$nextTick(() => {
          this.applySelect2Regions();
          this.applySelect2Types();
          this.applySelect2Ages();
        });
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getCitiesList(){
      this.citiesList = [];
      this.cityId = null;
      this.neighborhoodsList = [];
      this.neighborhoodId = null;
      this.$nextTick(() => {
        this.applySelect2Cities();
        this.applySelect2Neighborhoods();
      });
      if(!this.regionId) return;
      this.$http.get(`/api/admin/cities/list?regionId=${this.regionId}&all=1`).then(({data}) => {
        this.citiesList = data.cities;
        this.$nextTick(() => {
          this.applySelect2Cities();
        });
      });
    },
    getNeighborhoodsList(){
      this.neighborhoodsList = [];
      this.neighborhoodId = null;
      this.$nextTick(() => {
        this.applySelect2Neighborhoods();
      });
      if(!this.cityId) return;
      this.$http.get(`/api/admin/neighborhoods/list?cityId=${this.cityId}&all=1`).then(({data}) => {
        this.neighborhoodsList = data.neighborhoods ?? [];
        this.$nextTick(() => {
          this.applySelect2Neighborhoods();
        });
      });
    },
    applySelect2Regions(){
      if(!this.$refs.regionsSelect){
        setTimeout(() => this.applySelect2Regions(), 200);
        return;
      }
      const vm = this;
      const $el = $(this.$refs.regionsSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.regionsSelect2');
        $el.select2('destroy');
      }
      $el.select2({
        width: '100%'
      });
      $el.val(this.regionId).trigger('change.select2');
      $el.on('change.regionsSelect2', function(){
        const v = $(this).val();
        vm.regionId = v ? parseInt(v, 10) : null;
        vm.getCitiesList();
      });
    },
    applySelect2Cities(){
      if(!this.$refs.citiesSelect){
        setTimeout(() => this.applySelect2Cities(), 200);
        return;
      }
      const vm = this;
      const $el = $(this.$refs.citiesSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.citiesSelect2');
        $el.select2('destroy');
      }
      $el.select2({
        width: '100%'
      });
      $el.val(this.cityId).trigger('change.select2');
      $el.on('change.citiesSelect2', function(){
        const v = $(this).val();
        vm.cityId = v ? parseInt(v, 10) : null;
        vm.getNeighborhoodsList();
      });
    },
    applySelect2Neighborhoods(){
      if(!this.$refs.neighborhoodsSelect){
        setTimeout(() => this.applySelect2Neighborhoods(), 200);
        return;
      }
      const vm = this;
      const $el = $(this.$refs.neighborhoodsSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.neighborhoodsSelect2');
        $el.select2('destroy');
      }
      $el.select2({
        width: '100%'
      });
      $el.val(this.neighborhoodId).trigger('change.select2');
      $el.on('change.neighborhoodsSelect2', function(){
        const v = $(this).val();
        vm.neighborhoodId = v ? parseInt(v, 10) : null;
      });
    },
    applySelect2Types(){
      if(!this.$refs.typesSelect){
        setTimeout(() => this.applySelect2Types(), 200);
        return;
      }
      const vm = this;
      const $el = $(this.$refs.typesSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.typesSelect2');
        $el.select2('destroy');
      }
      $el.select2({
        width: '100%'
      });
      $el.val(this.typeId).trigger('change.select2');
      $el.on('change.typesSelect2', function(){
        const v = $(this).val();
        vm.typeId = v ? parseInt(v, 10) : null;
      });
    },
    applySelect2Ages(){
      if(!this.$refs.agesSelect){
        setTimeout(() => this.applySelect2Ages(), 200);
        return;
      }
      const vm = this;
      const $el = $(this.$refs.agesSelect);
      if($el.hasClass('select2-hidden-accessible')){
        $el.off('change.agesSelect2');
        $el.select2('destroy');
      }
      $el.select2({
        width: '100%'
      });
      $el.val(this.ageId).trigger('change.select2');
      $el.on('change.agesSelect2', function(){
        const v = $(this).val();
        vm.ageId = v ? parseInt(v, 10) : null;
      });
    },
    submitData(){
      this.hasError = false;
      this.hasSuccess = false;

      if(!this.userId){
        this.message = 'يجب تحديد العميل عن طريق رقم الجوال أولاً';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if(!this.purpose || !this.typeId || !this.regionId || !this.cityId){
        this.message = 'يرجى تعبئة جميع الحقول المطلوبة (الغرض، نوع العقار، المنطقة، المدينة)';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      this.formLoader = true;
      this.$http.post('/api/admin/propertyRequests/create', {
        userId: this.userId,
        purpose: this.purpose,
        typeId: this.typeId,
        regionId: this.regionId,
        cityId: this.cityId,
        neighborhoodId: this.neighborhoodId,
        age: this.ageId,
        priceFrom: this.priceFrom ? parseInt(this.priceFrom) : 0,
        priceTo: this.priceTo ? parseInt(this.priceTo) : 0,
        area: this.area,
        areaTo: this.areaTo,
        roomsCount: this.roomsCount ? parseInt(this.roomsCount) : 0,
        extraDetails: this.extraDetails,
      }).then(({data}) => {
        toast('تم إضافة الطلب بنجاح', 'success');
        this.$router.push(`/proRequest/update/${data.row.id}`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    this.getInitData();
    this.applySelect2Types();
    this.applySelect2Regions();
    this.applySelect2Cities();
    this.applySelect2Neighborhoods();
    this.applySelect2Ages();
  }
}
</script>